import Attribute from './model.attribute';

var Legislation = function(legislationObj) {
    var self = this;

    self.attributeMap = {};

    self.id = legislationObj.Id;
    self.name = legislationObj.CountryName;
    self.countryId = legislationObj.CountryId;
    self.legislationId = legislationObj.LegislationId;
    self.description = legislationObj.Description;
    self.attributes = [];
    self.roadNames = legislationObj.roadNames;

    legislationObj.Attributes.forEach(function (attribute) {
        self.attributes.push(new Attribute(attribute));
    });

    function evaluate(attributeType) {
        
        
        if(self.attributeMap[attributeType]) {
            return self.attributeMap[attributeType];
        }
        var returnVal;
        var tempVal = self.attributes.filter(function (attribute) {
            return attributeType === attribute.name.toUpperCase();
        });
        returnVal = tempVal[0];
        self.attributeMap[attributeType] = returnVal;
        return returnVal;
    }

    self.evaluate = evaluate;
}

export default Legislation;
